import { Provider } from '@angular/core'

import { LanguageService } from '@ti/core/ui-kit/i18n'

import { TiAdminLanguageService } from './language.service'

export * from './language.service'

export const LANG_PROVIDERS: Provider[] = [
  {
    provide: LanguageService,
    useClass: TiAdminLanguageService,
  },
]
